import { push } from 'react-router-redux';
import Cookies from 'js-cookie';


////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// SEND RESET PASSWORD LINK
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestResetPassword = packet => {
  return {
    type: 'REQUEST_RESET_PASSWORD',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveResetPasswordSuccess = data => ({
  type: 'RECEIVE_RESET_PASSWORD_SUCCESS',
  data
})

export const receiveResetPasswordFail = data => ({
  type: 'RECEIVE_RESET_PASSWORD_FAIL',
  data
})

export const tryToResetPassword = packet => (dispatch, getState) => {

  dispatch(requestResetPassword(packet));

  let headers = {
    "Content-Type": "application/json",
  }

  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/users/reset-password', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveResetPasswordSuccess(json.data));
      dispatch(push('/sign-in'));
    })
    .catch(e => {
      dispatch(receiveResetPasswordFail({errors:e, lastSubmit: packet}));
    })
}
